<!-- 客户裂变 -->
<template>
    <div class='Clientfission'>
        <div class="topSw">
            <div @click="current = item" :class="current === item ? 'active' : ''" class="swBtn"
                v-for="(item, index) in selectBtn" :key="index">
                {{ item }}
            </div>
        </div>
        <div class="center">
            <div class="centerLine">
                <span>活动名称</span>
                <el-input style="width: 2rem; margin-right: 0.1rem" size="small" v-model="input"
                    placeholder="请输入"></el-input>
            </div>
            <div class="centerLine">
                <span>活动时间</span>
                <el-date-picker style="margin-right: 0.1rem" size="small" v-model="input" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div class="centerLine">
                <span>活动状态</span>
                <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in activeState" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <el-table :data="tableData" :header-cell-style="{
            color: '#000000'}" ref="multipleTable" @selection-change="handleSelectionChange" style="width: 100%" border>
            <el-table-column align="center" type="selection" width="55"> </el-table-column>
            <el-table-column align="center" prop="date" label="活动ID"> </el-table-column>
            <el-table-column align="center" prop="date" label="活动名称"> </el-table-column>
            <el-table-column align="center" prop="date" label="活动时间"> </el-table-column>
            <el-table-column align="center" prop="date" label="状态"> </el-table-column>
            <el-table-column align="center" prop="date" label="券详情"> </el-table-column>
            <el-table-column align="center" prop="date" label="平台推广渠道"> </el-table-column>
            <el-table-column align="center" prop="date" label="二维码及推广链接"> </el-table-column>
            <el-table-column align="center" prop="date" label="生成人"> </el-table-column>
            <el-table-column align="center" prop="date" label="操作"> </el-table-column>
        </el-table>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            current: '活动列表',
            selectBtn: ['活动列表', '活动数据'],
            activeState: [
                {
                    value: "1",
                    label: "全部",
                },
                {
                    value: "2",
                    label: "待开始",
                },
                {
                    value: "3",
                    label: "进行中",
                },
                {
                    value: "4",
                    label: "已暂停",
                },
                {
                    value: "5",
                    label: "已结束",
                },
            ],
            input: ""
        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.active {
    color: #ff4646 !important;
    background-color: #fff !important;
    border-top: 2px solid #ff4646 !important;
    border-bottom: none !important;
}

.Clientfission {
    background-color: #fff;
    padding: 0.23rem 0.3rem;

    .topSw {
        padding: 0 0.25rem;
        display: flex;
        align-content: center;
        border-bottom: 1px solid #F4F6F8;
        margin-bottom: 0.35rem;

        .swBtn {
            cursor: pointer;
            padding: 0.1rem 0.15rem;
            background: #fff;
            border: 1px solid #ccc;
            border-bottom: none;
            color: #565c6a;
            background: #f5f7f9;
            margin-right: 0.1rem;
        }
    }

    .center {
        display: flex;
        align-items: center;

        .centerLine {
            display: flex;
            align-items: center;
            margin-right: 0.2rem;
            margin-bottom: 0.35rem;
            span {
                margin-right: 0.1rem;
            }
        }
    }
}
</style>